import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_SCHEDULING_INFO_FIELDS } from '@src/graphql/fragments/ehrAppointmentSchedulingInfo'

export const EHR_APPOINTMENT_SCHEDULING_INFO = gql`
  ${EHR_APPOINTMENT_SCHEDULING_INFO_FIELDS}
  query ehrAppointmentSchedulingInfo($meetingAt: ISO8601DateTime) {
    ehrAppointmentSchedulingInfo(meetingAt: $meetingAt) {
      mnt {
        ...EhrAppointmentSchedulingInfoFields
      }
      stressManagement {
        ...EhrAppointmentSchedulingInfoFields
      }
    }
  }
`
